import React, { PureComponent } from 'react';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import { Add, Text, LinkText } from './styles';

export default class CheckoutAdd extends PureComponent {
    render() {
        const { text, to, linkText } = this.props;
        return (
            <Add>
                {!!text && (
                    <Text>
                        <Translator tk={text} />
                    </Text>
                )}
                {!!linkText && (
                    <LinkText to={to}>
                        <Translator tk={linkText} />
                    </LinkText>
                )}
            </Add>
        );
    }
}
